import { useState, type ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { detectLegalLang, type LegalLang } from '../../lib/legalLang';
import { LegalNav } from '../../components/legal/LegalChrome';

type Doc = 'terms' | 'host-agreement' | 'privacy';

const TITLES: Record<Doc, Record<LegalLang, string>> = {
  terms: { pt: 'Termos de Serviço', en: 'Terms of Service' },
  privacy: { pt: 'Política de Privacidade', en: 'Privacy Notice' },
  'host-agreement': { pt: 'Acordo de Anfitrião', en: 'Host Agreement' },
};

/** Shared frame for the public legal pages: title, language switch, links between documents. */
export function LegalPage({ doc, children }: { doc: Doc; children: (lang: LegalLang) => ReactNode }) {
  const [lang, setLang] = useState<LegalLang>(detectLegalLang);
  return (
    <div className="min-h-dvh bg-app-bg">
      <div className="max-w-2xl mx-auto px-4 py-8">
        <Link to="/" className="text-sm text-gold underline underline-offset-2 mb-4 inline-block">&larr; {lang === 'pt' ? 'Voltar' : 'Back'}</Link>
        <h1 className="font-serif text-3xl text-app-fg mb-4">{TITLES[doc][lang]}</h1>
        <LegalNav lang={lang} onLang={setLang} current={doc} />
        {children(lang)}
      </div>
    </div>
  );
}
